<app-admin-header
  style="width: 100%"
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="[]"
></app-admin-header>

<!-- SECTION PAGE 23 Start-->
<section class="container-fluid v4-bg-img 77777 py-5">
  <div class="ms-pg-structure container">
    <app-project-details-card
      *ngIf="channels && project && !skelition"
      [project]="project"
      [channels]="basicChannels"
      [branches]="selectedBranches"
    ></app-project-details-card>
    <div class="white-box">
      <div class="row db-p-05 mob-padding-pg-24">
        <div class="col-md-12 col-12 db-p-05">
          <div class="row db-p-05 justify-content-center">
            <div
              class="col-md-3 col-6 db-p-05"
              *ngFor="let channel of basicChannels"
            >
              <div class="d-flex justify-content-center">
                <div class="main-db-tabs column-24">
                  <span><i class="fa-solid fa-house-laptop mx-2"></i></span>
                  <span class="font-24-8">{{ channel.name | translator }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-12 db-p-05">
              <div class="row db-p-05 justify-content-center">
                <div
                  class="col-md-3 col-6 grey-box-flex db-p-05"
                  *ngFor="let channel of basicChannels"
                >
                  <div class="main-db-grey-tabs">
                    <p class="grey-box-text">
                      {{ "Visits" | translator }}
                    </p>

                    <div class="d-flex justify-content-end">
                      <span
                        *ngIf="channel.name != 'Branches'"
                        class="long-box-num"
                        >{{ channel.visitCount }}</span
                      >
                      <span
                        *ngIf="channel.name == 'Branches'"
                        class="long-box-num"
                        >{{
                          channel.visitCount * selectedBranches.length
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row db-p-05 justify-content-center">
            <div
              class="col-md-3 col-6 db-p-05"
              *ngFor="let channel of selectedBranches"
            >
              <div class="d-flex justify-content-center">
                <div class="main-db-tabs column-24">
                  <span><i class="fa-solid fa-house-laptop mx-2"></i></span>
                  <span class="font-24-8"
                    >{{ channel.name | translator }}
                    <span
                      *ngIf="
                        channel.branchId &&
                        branchCities &&
                        branchCities[channel.branchId]
                      "
                    >
                      - ({{ branchCities[channel.branchId] }})</span
                    >
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-12 db-p-05">
              <div class="row db-p-05 justify-content-center">
                <div
                  class="col-md-3 col-6 grey-box-flex db-p-05"
                  *ngFor="let channel of selectedBranches"
                >
                  <div class="main-db-grey-tabs">
                    <p class="grey-box-text">
                      {{ "Visits" | translator }}
                    </p>
                    <div class="d-flex justify-content-end">
                      <span class="long-box-num">{{
                        getBranchVisitCountNum | number
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row db-p-05 mob-padding-pg-24">
        <div class="col-md-6 col-12 db-p-05">
          <div
            class="purple-box d-flex justify-content-center align-items-center"
          >
            <div>
              <p class="grey-box-text">
                {{ "Total Targets of the project" | translator }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 db-p-05">
          <div
            class="purple-box d-flex justify-content-center align-items-center"
          >
            <div>
              <p class="grey-box-text">
                {{ "Scope" | translator }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="grey-box-tab mob-padding-pg-24 vvvvv">
        <div class="row db-p-05">
          <div class="col-lg-5 col-md-12 col-12 db-p-05">
            <h4 class="dashboard-medium-h-24">
              {{ "Branches" | translator }}
            </h4>

            <div class="w-h-fill p-2">
              <!-- <img class="dummy-work" src="../../../../../assets/graph.png" alt="loading"> -->

              <p-chart
                height="350px"
                type="bar"
                [data]="data"
                [options]="options2"
              ></p-chart>
            </div>
          </div>

          <div class="col-lg-3 col-md-12 col-12 db-p-05">
            <h4 class="dashboard-medium-h-24">
              {{ "SBC" | translator }}
            </h4>

            <div class="w-h-fill p-2">
              <!-- <img class="dummy-work" src="../../../../../assets/graph.png" alt="loading"> -->

              <p-chart
                height="350px"
                type="pie"
                [data]="sbcGraphData"
                [options]="options"
              ></p-chart>
            </div>
          </div>

          <div class="col-lg-4 col-md-12 col-12 db-p-05">
            <h4 class="dashboard-medium-h-24">
              {{ "Channels" | translator }}
            </h4>
            <div class="flex-23">
              <div class="m-1">
                <div class="dashboard-purple-box-23 mb-3">#</div>
                <div
                  class="dashboard-white-box-23"
                  *ngFor="let channel of basicChannels; let i = index"
                >
                  {{ i + 1 }}
                </div>
              </div>
              <div class="width-100 m-1">
                <div class="dashboard-purple-box mb-3 text-center">
                  {{ "Channel" | translator }}
                </div>
                <div
                  class="dashboard-white-box text-center"
                  *ngFor="let channel of basicChannels"
                >
                  {{ channel.name | translator }}
                </div>
              </div>
              <div class="width-100 m-1">
                <div class="dashboard-purple-box mb-3 text-center">
                  {{ "Weight" | translator }}
                </div>
                <div
                  class="dashboard-white-box text-center"
                  *ngFor="let channel of basicChannels"
                >
                  {{ channel.weight }}
                </div>

                <div class="dashboard-purple-box mb-3 text-center">
                  {{ "Total" | translator }}
                </div>
              </div>
              <div class="width-100 m-1">
                <div class="dashboard-purple-box mb-3 text-center">
                  {{ "Grade" | translator }} %
                </div>
                <div
                  class="dashboard-white-box text-center"
                  *ngFor="let channel of basicChannels"
                >
                  <span *ngIf="channel.awaitingEval">
                    {{ channel.percentage ?? 0 | number : "1.2-2" }}%
                  </span>
                  <span *ngIf="!channel.awaitingEval"> N/A </span>
                </div>

                <div class="dashboard-purple-box mb-3 text-center">
                  {{ this.totalBasicChannelsPercentage | number : "1.2-2" }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr class="hr" />
          </div>

          <div class="col-lg-12 col-md-12 col-12 db-p-05">
            <h4 class="dashboard-medium-h-24">
              {{ "Grade of Each Branch" | translator }}
            </h4>
            <p-table [value]="selectedBranches">
              <ng-template pTemplate="header">
                <tr>
                  <th rowspan="1">
                    {{ "Name" | translator }}
                  </th>
                  <th rowspan="1">
                    {{ "Weight" | translator }}
                  </th>
                  <th
                    class="text-center"
                    [attr.colspan]="
                      selectedBranches
                        ? objectKeys(selectedBranches[0].averages).length
                        : 1
                    "
                  >
                    {{ "Criterias" | translator }}
                  </th>
                  <th rowspan="1">
                    {{ "By Weightage" | translator }}
                  </th>
                  <th rowspan="1">
                    {{ "Percentage" | translator }}
                  </th>
                  <th rowspan="1"></th>
                </tr>
                <br />
                <tr>
                  <ng-container
                    *ngIf="selectedBranches && selectedBranches.length > 0"
                  >
                    <th></th>
                    <th></th>
                    <th
                      *ngFor="
                        let key of objectKeys(selectedBranches[0].averages)
                      "
                    >
                      {{ key }}
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td>
                    {{ item.name }}
                    <span
                      *ngIf="
                        item.branchId &&
                        branchCities &&
                        branchCities[item.branchId]
                      "
                    >
                      - ({{ branchCities[item.branchId] }})</span
                    >
                  </td>
                  <td>{{ item.weight }}%</td>
                  <td *ngFor="let key of objectKeys(item.averages)">
                    {{
                      (item.averages[key].sum / item.averages[key].count) * 20
                        | number : "1.2-2"
                    }}%
                  </td>
                  <td>
                    {{ item.byweightage | number : "1.2-2" }}
                  </td>
                  <td>{{ item.percentage | number : "1.2-2" }}%</td>
                </tr>
              </ng-template>
              <!-- Footer Template for Sum -->
              <ng-template class="v4-tab-footer" pTemplate="footer">
                <tr>
                  <td colspan="4"></td>
                  <td>
                    <strong>{{ "Total" | translator }}</strong>
                  </td>
                  <td>{{ calculateTotal() | number : "1.2-2" }}%</td>
                  <td></td>
                  <td></td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div class="col-12">
            <hr class="hr" />
          </div>

          <div class="col-12">
            <h4 class="dashboard-medium-h-24">
              {{ "Comments" | translator }}
            </h4>
            <div class="row">
              <div
                *ngFor="let comment of allComments"
                class="col-md-3 col-12 my-2"
              >
                <p-card class="v4-ms-card">
                  <p *ngIf="comment.factor">
                    <b class="v4-color-white">{{ comment.factor.factor }}</b>
                    <br />
                    <i class="v4-color-white"> {{ comment.factor.main }} </i>
                    <br />
                    <small class="v4-color-white">{{
                      comment.factor.sub
                    }}</small>
                  </p>
                  <h5 class="dashboard-medium-h-24 v4-color-white">
                    {{ comment.comment }}
                  </h5>
                  <p-progressBar
                    [value]="comment.percentage"
                    [style]="{ height: '6px' }"
                    [showValue]="false"
                    [styleClass]="getColorClass(comment.percentage)"
                  ></p-progressBar>

                  <p
                    *ngIf="comment.channel != 'Branches'"
                    class="m-0 v4-color-white"
                  >
                    {{ comment.channel }}
                  </p>
                  <p class="v4-color-white" *ngIf="comment.branch">
                    {{ comment.branch.name }}
                    ({{ branchCities[comment.branch.branchId] }})
                  </p>
                </p-card>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr class="hr" />
          </div>

          <div class="col-12">
            <h4 class="dashboard-medium-h-24">
              {{ "Factors Table" | translator }}
            </h4>
            <p-table [value]="scoringByFactor">
              <ng-template pTemplate="header">
                <tr>
                  <th>{{ "Main Criteria" | translator }}</th>
                  <th>{{ "Sub Criteria" | translator }}</th>
                  <th>{{ "Factor" | translator }}</th>
                  <th>{{ "MSMarks" | translator }}</th>
                  <th>{{ "Grade" | translator }}</th>
                  <th>{{ "Sub Criteria Grade %" | translator }}</th>
                  <th>{{ "Criteria Grade %" | translator }}</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-item let-i="index">
                <ng-container
                  *ngFor="let child of item.data; let isFirstItem = first"
                >
                  <ng-container
                    *ngFor="let gran of child.data; let isFirstChild = first"
                  >
                    <tr>
                      <td
                        *ngIf="isFirstItem && isFirstChild"
                        [attr.rowspan]="calculateRowspan(item)"
                      >
                        {{ item.name }}
                      </td>
                      <td
                        *ngIf="isFirstChild"
                        [attr.rowspan]="calculateRowspan(child)"
                      >
                        {{ child.name }}
                      </td>
                      <td>{{ gran.name }}</td>
                      <td>
                        {{ gran.data | number : "1.2-2" }}
                      </td>
                      <td>{{ gran.data * 20 | number : "1.2-2" }}%</td>
                      <td
                        *ngIf="isFirstChild"
                        [attr.rowspan]="calculateRowspan(child)"
                      >
                        {{ calculateGrade(child) | number : "1.2-2" }}%
                      </td>
                      <td
                        *ngIf="isFirstItem && isFirstChild"
                        [attr.rowspan]="calculateRowspan(item)"
                      >
                        {{ calculateCriteriaGrade(item) | number : "1.2-2" }}
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-template>
              <br />
              <br />
              <ng-template class="v4-tab-footer" pTemplate="footer">
                <tr>
                  <td colspan="5"></td>
                  <td>
                    <strong>{{ "Total" | translator }}</strong>
                  </td>
                  <td>
                    <!-- {{ calculateTotalByFactor() | number :
                                        '1.2-2' }} -->

                    {{ this.totalBasicChannelsPercentage | number : "1.2-2" }}%
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--
<section class="container-fluid ms-main-bg py-4">
    <div class="ms-pg-structure container">
        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">{{'Dashboard-Reports' | translator}}</h4>
            </div>
        </div>

        <div class="white-box">
            <div class="grey-box">
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="column my-2">
                            <h5 class="medium-h">
                                {{"Criteria" | translator }}
                            </h5>
                            <div>
                                <select
                                    class="ms-dropdown-pg-22"
                                    [(ngModel)]="current.criteria"
                                    (ngModelChange)="selectEnquiry()"
                                >
                                    <option
                                        *ngFor="let criteria of criterias; let i=index"
                                        [value]="i"
                                    >
                                        {{criteria.criteria}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="column my-2">
                            <h5 class="medium-h">
                                {{'Sub Criteria' | translator}}
                            </h5>
                            <div>
                                <select
                                    class="ms-dropdown-pg-22"
                                    [(ngModel)]="current.subcriteria"
                                    (ngModelChange)="selectEnquiry()"
                                >
                                    <option
                                        *ngFor="let criteria of criterias[current.criteria]?.['sub-criterias']; let i=index"
                                        [value]="i"
                                    >
                                        {{ criteria?.criteria }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12">
                        <div class="column my-2">
                            <h5 class="medium-h">{{'Factor' | translator}}</h5>
                            <div>
                                <select
                                    class="ms-dropdown-pg-22"
                                    [(ngModel)]="current.factor"
                                    (ngModelChange)="selectEnquiry()"
                                >
                                    <option
                                        *ngFor="let criteria of criterias[current.criteria]?.['sub-criterias']?.[current.subcriteria]?.['factors']; let i=index"
                                        [value]="i"
                                    >
                                        {{criteria.factor}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div
                    class="col-lg-12 col-md-12 col-12"
                    *ngFor="let enquiry of enquiriesToShow; let i= index;"
                >
                    <div class="dashboard-grey-box">
                        <div
                            class="d-flex flex-column align-items-start align-content-start"
                        >
                            <div>
                                <h4 class="medium-h">
                                    <i
                                        class="fa fa-question-circle p-2"
                                        aria-hidden="true"
                                    ></i>
                                    {{enquiry.enquiry}}
                                </h4>
                            </div>
                            <div
                                class="d-flex align-content-center align-items-center"
                            >
                                <span class="medium-h"
                                    ><i
                                        class="fa fa-check-circle p-2"
                                        aria-hidden="true"
                                    ></i>
                                    {{enquiry.correctAnswer}}</span
                                >
                                <span class="medium-h p-2"> | </span>
                                <span class="medium-h"
                                    ><i
                                        class="fa fa-link p-2"
                                        aria-hidden="true"
                                    ></i>
                                    {{enquiry.serviceUrl}}</span
                                >
                            </div>

                            <div
                                class="grey-box"
                                *ngIf="enquiriesToShow && enquiriesToShow[0]"
                            >
                                <table>
                                    <thead>
                                        <tr>
                                            <th scope="col" style="width: 4%">
                                                #
                                            </th>
                                            <th scope="col" style="width: 24%">
                                                {{"Channel" | translator}}
                                            </th>
                                            <th scope="col" style="width: 24%">
                                                {{"Branch" | translator}}
                                            </th>
                                            <th scope="col" style="width: 10%">
                                                {{"Grade" | translator}}
                                            </th>
                                            <th scope="col" style="width: 14%">
                                                {{"Employee Answer" |
                                                translator}}
                                            </th>
                                            <th scope="col" style="width: 24%">
                                                {{"Comments" | translator}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let enquiry of enquiriesToShow[0].evals;let i=index"
                                        >
                                            <td data-label="">
                                                <span
                                                    class="ms-tabel-td-mob-mr"
                                                >
                                                    <div
                                                        class="d-flex tab-num-border-white"
                                                    >
                                                        <div>
                                                            <div
                                                                class="ms-tabel-num-box"
                                                            >
                                                                {{ i + 1 }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </span>
                                            </td>
                                            <td data-label="Channel">
                                                <span
                                                    class="ms-tabel-td-mob-mr"
                                                >
                                                    <div
                                                        class="tabel-detail-box"
                                                    >
                                                        {{
                                                        enquiry?.channel?.name
                                                        }} ‎
                                                    </div>
                                                </span>
                                            </td>
                                            <td data-label="Branch">
                                                <span
                                                    class="ms-tabel-td-mob-mr"
                                                >
                                                    <div
                                                        class="tabel-detail-box"
                                                    >
                                                        {{ enquiry?.branch?.name
                                                        }} ‎
                                                    </div>
                                                </span>
                                            </td>
                                            <td data-label="Grade">
                                                <span
                                                    class="ms-tabel-td-mob-mr"
                                                >
                                                    <div
                                                        class="tabel-detail-box"
                                                        *ngFor="let fact of enquiry.factors"
                                                    >
                                                        {{ fact.grade }} ‎
                                                    </div>
                                                </span>
                                            </td>
                                            <td data-label="Employee Answer">
                                                <span
                                                    class="ms-tabel-td-mob-mr"
                                                >
                                                    <div
                                                        class="tabel-detail-box"
                                                        *ngFor="let evals of enquiry.evals"
                                                    >
                                                        {{ evals.employeeAnswer
                                                        }} ‎
                                                    </div>
                                                </span>
                                            </td>
                                            <td data-label="Comments">
                                                <span
                                                    class="ms-tabel-td-mob-mr"
                                                >
                                                    <div
                                                        class="tabel-detail-box"
                                                        *ngFor="let evals of enquiry.evals"
                                                    >
                                                        {{ evals.msComments }}
                                                    </div>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- <section class="container-fluid ms-main-bg  py-4">
    <div class="container ms-pg-structure">
        <div class="row flex-white-box-row-mob white-box-row">
            <div class="col-md-3 col-12">
                <div class="d-flex align-items-center mob-w-100">
                    <div>
                        <div class="number-box">
                            01
                        </div>
                    </div>
                    <img class="row-img" [src]="staticURL + project?.vendor?.image" alt="loading">
                    <h5 class="medium-h-row">{{extractUsername(project?.vendor?.name)}}</h5>
                </div>
            </div>
            <div class="col-md-7 col-12">
                <div class="d-flex flex-wrap mob-m-t-b-1rem">
                    <div [pTooltip]="project?.vendor?.vendorExtraDetails?.classification" tooltipPosition="top" class="detail-box"><i
                            class="pi pi-building icon-ml"></i>{{project?.vendor?.vendorExtraDetails?.classification}}
                    </div>
                    <div [pTooltip]="project?.vendor?.vendorExtraDetails?.companyName" tooltipPosition="top" class="detail-box"><i
                            class="fa fa-location-dot icon-ml"></i>{{project?.vendor?.vendorExtraDetails?.companyName?.substring(0,10)}} {{project?.vendor?.vendorExtraDetails?.companyName.length >10 ? "..." : null}}
                    </div>
                    <div [pTooltip]="project?.vendor?.email" tooltipPosition="top" class="detail-box"><i class="fa-regular fa-envelope icon-ml"></i>{{project?.vendor?.email?.substring(0,10)}} {{project?.vendor?.email.length >10 ? "..." : null}}
                    </div>
                    <div [pTooltip]="project?.vendor?.phone" tooltipPosition="top" class="detail-box"><i class="fa-solid fa-phone icon-ml"></i>{{project?.vendor?.phone?.substring(0,10)}} {{project?.vendor?.phone.length >10 ? "..." : null}}</div>
                </div>
            </div>
            <div class="col-md-2 col-12">
                <div class="responsive-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>
        </div>

        <div class="row flex-white-box-row-mob white-box-row">
            <div class="col-md-3 col-12">
                <div class="d-flex align-items-center mob-w-100">
                    <div>
                        <div class="number-box">
                            02
                        </div>
                    </div>
                    <img class="row-img" [src]="staticURL + project?.vendor?.image" alt="loading">
                    <h5 class="medium-h-row">{{project?.vendor?.vendorExtraDetails?.altPmName}}</h5>
                </div>
            </div>
            <div class="col-md-7 col-12">
                <div class="d-flex flex-wrap mob-m-t-b-1rem">
                    <div [pTooltip]="project?.vendor?.vendorExtraDetails?.classification" tooltipPosition="top" class="detail-box"><i
                            class="pi pi-building icon-ml"></i>{{project?.vendor?.vendorExtraDetails?.classification?.substring(0,10)}} {{project?.vendor?.vendorExtraDetails?.classification.length >10 ? "..." : null}}
                    </div>
                    <div [pTooltip]="project?.vendor?.vendorExtraDetails?.companyName" tooltipPosition="top" class="detail-box"><i
                            class="fa fa-location-dot icon-ml"></i>{{project?.vendor?.vendorExtraDetails?.companyName?.substring(0,10)}} {{project?.vendor?.vendorExtraDetails?.companyName.length >10 ? "..." : null}}
                    </div>
                    <div [pTooltip]="project?.vendor?.vendorExtraDetails?.altPmEmail" tooltipPosition="top" class="detail-box"><i
                            class="fa-regular fa-envelope icon-ml"></i>{{project?.vendor?.vendorExtraDetails?.altPmEmail?.substring(0,10)}} {{project?.vendor?.vendorExtraDetails?.altPmEmail.length >10 ? "..." : null}}
                    </div>
                    <div [pTooltip]="project?.vendor?.vendorExtraDetails?.altPmMobile" tooltipPosition="top" class="detail-box"><i
                            class="fa-solid fa-phone icon-ml"></i>{{project?.vendor?.vendorExtraDetails?.altPmMobile?.substring(0,10)}} {{project?.vendor?.vendorExtraDetails?.altPmMobile.length >10 ? "..." : null}}
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-12">
                <div class="responsive-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
<app-footer></app-footer>
